
import { Options, Vue } from 'vue-class-component';

import { event } from 'vue-gtag';

@Options({
  components: {
  },
  computed: {
    CMS_URL () {
      return this.$store.getters.getCMSURL;
    },
    posts () {
      return this.$store.getters.getPosts;
    }
  }
})
export default class NewsPost extends Vue {

  CMS_URL;
  lightboxListeners = [];
  activePost = null;
  parsed = false;
  posts;
  pages = [];
  slideIndex = 0;
  scrolled = false;
  public lightboxSrc;
  
  created() {
    //console.log(this.$route.params.id);
    this.getPosts();
  }

  mounted() {
    let cookies = (this.$parent as any).$root.cookies,
      gdprCookie = cookies.get("gdprCookie"),
      id = this.$route.params.id;

    if(gdprCookie == 'true') {

      event(null, { 
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'News Post',
        action: 'click',
        label: 'News Post View: '+id,
        value: 5000,
        noninteraction: false, // Optional
      });

    }

    window.addEventListener('scroll', this.handleScroll);
    

  }

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);

  }

  getPosts() {
    if(!this.posts) {
      this.axios.get(this.CMS_URL + 'mt7rk/posts').then((response) => {
        //console.log(response.data);
        this.$store.commit('setPosts', JSON.parse(response.data).posts);
        //console.log(this.posts);
        this.getActivePost(this.$route.params.id)

      });
    } else {
        this.getActivePost(this.$route.params.id);
    }
  }

  getActivePost(id) {
    //console.log(id);
    

    for(let i = 0; i < this.posts.news.length; i++) {
        if(this.posts.news[i].ID == id) {
            //console.log(this.posts.news[i].ID);

            this.activePost = i;
            //this.$forceUpdate();
            this.generatePages();
            
        }
    }
  } 

  generatePages() {

    for(let i = 0; i < this.posts.news.length; i++) {
      if(!this.pages[Math.floor(i / 5)]) {
        this.pages[Math.floor(i / 5)] = [];
      }

      this.pages[Math.floor(i / 5)].push(this.posts.news[i]);

      /*if(i == this.posts.news.length-1) {
        console.log(this.pages);
      }*/
    }
  }

  setActivePost(index) {
    this.activePost = index;
    history.pushState(
        {},
        null,
        '/news/'+this.posts.news[index].ID
    )
    this.$forceUpdate();

    setTimeout(() => {
      window.scrollTo(0, 0); // values are x,y-offset
    }, 10);

  }

  moveSlider(dir) {
    this.slideIndex += dir;
    this.activePost = 0;
  }

  handleScroll() {
    //console.log("sup");

    //let height = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);

    let room = window.innerHeight - 100 - document.getElementById("newsWrap").offsetHeight;
    //console.log(room);
    //console.log(((document as any).scrollingElement.clientHeight));

    let height = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    height = height - window.innerHeight;
    
    //console.log("height: " +(height - (350 + room))+", scroll: "+document.scrollingElement.scrollTop)

    if((document.scrollingElement.scrollTop) > Math.abs(height - (350 + room))) {
      //console.log("good");
      this.scrolled = true;
    } else {
      this.scrolled = false;
    }

    //this.scrollPos = window.scrollY;
  }
}
